import * as Yup from "yup"
import _ from "lodash"


export default function validation_conditional_checkbox(field, acc) {
  const { field_name, field_validation } = field

  const conditions = JSON.parse(field.field_conditional)
  const fieldConditional = _.keys(conditions)
  const conditionFieldName = fieldConditional[0]

  const checkBool = () => {
    if (!field_validation.required) return false
    return field_validation.required[0] === "true" ? true : false
  }

  const isRequired = checkBool()
  const isRequiredTxt =
    (field_validation.required && field_validation.required[1]) ||
    "Required field."

  if (!isRequired) return acc

  return {
    ...acc,
    [field_name]: Yup.array()
      .nullable()
      .when(conditionFieldName, (value, schema) => {
        const matches = _.isArray(value)
          ? _.some(value, (v) => _.includes(conditions[conditionFieldName], v))
          : _.includes(conditions[conditionFieldName], value)

        return matches
          ? schema.min(1, isRequiredTxt).required()
          : schema
      }),
  }
}
